module.exports = __webpack_public_path__ + "img/banner_avatarposter.9c1442d4.jpg";